"use strict";
// Copyright 2020-2022 SubQuery Pte Ltd authors & contributors
// SPDX-License-Identifier: Apache-2.0
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IPFSClient = void 0;
const buffer_1 = __importDefault(require("buffer"));
const ipfs_http_client_1 = require("ipfs-http-client");
const utils_1 = require("../utils");
const Buffer = buffer_1.default.Buffer;
class IPFSClient {
    constructor(url) {
        this._client = (0, ipfs_http_client_1.create)({ url });
    }
    async getJSON(cid) {
        const raw = await this.cat(cid);
        return JSON.parse(raw);
    }
    async cat(cid, encoding = 'utf8') {
        var e_1, _a;
        const results = this._client.cat(cid);
        let raw;
        try {
            for (var results_1 = __asyncValues(results), results_1_1; results_1_1 = await results_1.next(), !results_1_1.done;) {
                const result = results_1_1.value;
                raw = raw ? (0, utils_1.concatU8A)(raw, result) : result;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (results_1_1 && !results_1_1.done && (_a = results_1.return)) await _a.call(results_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        if (!raw) {
            throw new Error(`Unable to fetch data from ipfs: ${cid}`);
        }
        return Buffer.from(raw).toString(encoding);
    }
    async add(entry) {
        const result = await this._client.add(entry, { pin: true });
        return result.cid.toV0().toString();
    }
    async image(url) {
        const cid = url.replace('ipfs://', '');
        if (!(0, utils_1.isCID)(cid))
            throw new Error(`Invalid cid: ${cid}`);
        const data = await this.cat(cid, 'base64');
        return `data:image/png;base64,${data}`;
    }
}
exports.IPFSClient = IPFSClient;
//# sourceMappingURL=ipfsClient.js.map